//#region ../schema-sql-parser/dist/parser/dataType/Snowflake.js
var SnowflakeTypes = [
	"ARRAY",
	"BIGINT",
	"BINARY",
	"BOOLEAN",
	"BYTEINT",
	"CHAR VARYING",
	"CHAR",
	"CHARACTER",
	"DATE",
	"DATETIME",
	"DEC",
	"DECFLOAT",
	"DECIMAL",
	"DOUBLE PRECISION",
	"DOUBLE",
	"FILE",
	"FLOAT",
	"FLOAT4",
	"FLOAT8",
	"GEOGRAPHY",
	"GEOMETRY",
	"INT",
	"INTEGER",
	"MAP",
	"NCHAR VARYING",
	"NCHAR",
	"NUMBER",
	"NUMERIC",
	"NVARCHAR",
	"NVARCHAR2",
	"OBJECT",
	"REAL",
	"SMALLINT",
	"STRING",
	"TEXT",
	"TIME",
	"TIMESTAMP WITH LOCAL TIME ZONE",
	"TIMESTAMP WITH TIME ZONE",
	"TIMESTAMP WITHOUT TIME ZONE",
	"TIMESTAMP_LTZ",
	"TIMESTAMP_NTZ",
	"TIMESTAMP_TZ",
	"TIMESTAMP",
	"TIMESTAMPLTZ",
	"TIMESTAMPNTZ",
	"TIMESTAMPTZ",
	"TINYINT",
	"UNKNOWN",
	"UUID",
	"VARBINARY",
	"VARCHAR",
	"VARCHAR2",
	"VARIANT",
	"VECTOR"
];
//#endregion
export { SnowflakeTypes };
